import setings from './settings'

export class AppSettings {

  static data = undefined

  static get(property) {
    if (!AppSettings.data) {
      return fetch(setings)
        .then(response => response.json())
        .then((data) => {
          AppSettings.data = data
          return this.data[property]
        })
    } else {
      return AppSettings.data[property]
    }
  }
}
